<template>
  <el-popover
      placement="right-start"
      trigger="click"
      width="400"
  >
    <template v-slot>
      <p>Click to insert the placeholder into the cursor position:</p>
      <div class="text-left">
        <item v-for="item in items" :key="item.key" :value="item" @select="onSelect"></item>
      </div>
    </template>
    <span slot="reference">
      <slot>
          Placeholders
      </slot>
    </span>
  </el-popover>
</template>

<script>
import Item from './item';

export default {
  components: {
    Item,
  },

  props: {
    items: Array,
  },

  methods: {
    /**
     * @param value
     * @emits select
     */
    onSelect(value) {
      this.$emit('select', value);
    },
  },
}
</script>

<style scoped>

</style>
